import { useQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'

import { getBookById } from '@/lib/api/book'
import BookForm from '@/components/forms/book-form'
import { Header } from '@/components/header'

export const Route = createFileRoute(
  '/_home/zone-settings/books-zone/edit/$id',
)({
  loader: async ({ params: { id } }) => {
    return { id }
  },
  component: EditBookPage,
})

function EditBookPage() {
  const { id } = Route.useLoaderData()
  const bookId = Number(id)
  const { data: bookById, isLoading } = useQuery({
    queryKey: ['getBookById'],
    queryFn: () => getBookById(bookId),
  })

  return (
    <main className="space-y-4 p-4">
      <Header
        subroutes={[
          {
            route: '/zone-settings/books-zone',
            label: 'Book zone',
          },
        ]}
      >
        Edit Book
      </Header>
    </main>
  )
}
